/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ArticleListItemDto
 */
export interface ArticleListItemDto {
    /**
     * 
     * @type {any}
     * @memberof ArticleListItemDto
     */
    id?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ArticleListItemDto
     */
    url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArticleListItemDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArticleListItemDto
     */
    icon?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArticleListItemDto
     */
    ingress?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ArticleListItemDto
     */
    changed?: Date;
    /**
     * 
     * @type {Array<ArticleListItemDto>}
     * @memberof ArticleListItemDto
     */
    children?: Array<ArticleListItemDto> | null;
}

/**
 * Check if a given object implements the ArticleListItemDto interface.
 */
export function instanceOfArticleListItemDto(value: object): value is ArticleListItemDto {
    return true;
}

export function ArticleListItemDtoFromJSON(json: any): ArticleListItemDto {
    return ArticleListItemDtoFromJSONTyped(json, false);
}

export function ArticleListItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArticleListItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] === undefined ? undefined : json['id'] === null ? null : json['id'],
        'url': json['url'] === undefined ? undefined : json['url'] === null ? null : json['url'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'icon': json['icon'] === undefined ? undefined : json['icon'] === null ? null : json['icon'],
        'ingress': json['ingress'] === undefined ? undefined : json['ingress'] === null ? null : json['ingress'],
        'changed': json['changed'] == null ? undefined : (new Date(json['changed'])),
        'children': json['children'] === undefined ? undefined : json['children'] === null ? null : ((json['children'] as Array<any>).map(ArticleListItemDtoFromJSON)),
    };
}

export function ArticleListItemDtoToJSON(json: any): ArticleListItemDto {
    return ArticleListItemDtoToJSONTyped(json, false);
}

export function ArticleListItemDtoToJSONTyped(value?: ArticleListItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'url': value['url'],
        'name': value['name'],
        'icon': value['icon'],
        'ingress': value['ingress'],
        'changed': value['changed'] == null ? value['changed'] : value['changed'].toISOString(),
        'children': value['children'] == null ? undefined : ((value['children'] as Array<any>).map(ArticleListItemDtoToJSON)),
    };
}

